import React from 'react';

function ShortagesList({ shortages }) {
    return (
        <ul>
            {shortages.map((shortage) => {
                const shortageDate = shortage.dtFimCarencia;
                return (
                    <li>
                        {shortage?.nomeProcedimento}: {shortageDate}
                    </li>
                );
            })}
        </ul>
    );
}

export default ShortagesList;
